import { getChartLabel } from "./chartLabel";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ZAxis,
  Scatter,
  ScatterChart,
  Cell,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";
import HeatmapChart from "./ScatterChart";
//kpi 7
const Evth_new = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "place", // default sort by place
    direction: "asc",
  });

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }
  const refData = data.map((item) => {
    return {
      place: item.Place,
      screened: Number(item.PW_tested_screened_for_HIV),
      reactive: Number(item.PW_Screened_reactive),
      confirmed: Number(item.PW_Confirmed_HIV_Positive),
      ppw: Number(item.New_PPW_linked_with_ART),
      loss:
        Number(item.PW_Confirmed_HIV_Positive) -
        Number(item.New_PPW_linked_with_ART),
      positivity: Number(item.new_data),
      known: Number(item.Known_PPW_linked_with_ART),
      //   percentage_linkage_referral: Number(item.Linkage_and_referral_COPW),
    };
  });

  const scatData = data.map((item) => {
    return {
      place: item.Place,

      hiv_positivity: Number(item.HIV_positivity) ?? 0,
      linkage_referral: Number(item.Linkage_and_referral_COPW) ?? 0,
    };
  });
  console.log("Scat:", scatData);

  const getColor = (value) => {
    if (value < 20) return "#006400"; // dark green
    if (value < 40) return "#66bb6a"; // green
    if (value < 60) return "#fff176"; // yellow
    if (value < 80) return "#ff8f00"; // orange
    return "#b71c1c"; // dark red
  };
  const sortedData = [...refData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Handle sorting click
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  // Icon display function
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⬍"; // default icon
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
    if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(refData.length);
  const chunkedData = chunkArray(refData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5>EVTHS Services (HIV)</h5>
            </div>

            <div class="cardDropDown gap-3">
              {/* <div style={{ marginRight: "30px" }}>{filterSlot}</div> */}
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th className="text-center fw-bold">PW Screened for HIV</th>
                  <th className="text-center fw-bold">PW Screened Reactive</th>
                  <th className="text-center fw-bold">PW Confirmed Reactive</th>
                  <th className="text-center fw-bold">PPW Linked With ART</th>
                  <th className="text-center fw-bold">Linkage Loss</th>
                  <th className="text-center fw-bold cursor-pointer">
                    PW Positivity
                  </th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("positivity")}
                  >
                    Known PPW on ART
                    {getSortIcon("known")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>

                    <td>{item.screened}</td>
                    <td>{item.reactive}</td>
                    <td>{item.confirmed}</td>
                    <td>{item.ppw}</td>
                    <td>{item.loss}</td>
                    <td>{item.positivity}%</td>
                    <td>{item.known}</td>
                    {/* <td>{item.percentage_linkage_referral}%</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          {chunkedData.map((chunk, index) => (
            <div className="card hptCard mt-4 border-0">
              {/* <div className="card-body">
                <h6 style={{ fontWeight: "bold" }}>
                  HIV Counselling and Testing Services
                </h6>
              </div> */}
              <ResponsiveContainer width="100%" height={500}>
                <BarChart
                  width={500}
                  height={500}
                  data={chunk}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  {/* <CartesianGrid strokeDasharray="3 3" /> */}
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis
                    yAxisId="left"
                    orientation="left"
                    //stroke="#8884d8"
                    label={{
                      value: "",
                      angle: -90,
                      position: "outside",
                      offset: -100,
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={
                      <CustomLegend
                        order={[
                          "PW Screened Reactive",
                          "PW confirmed Reactive",
                          "PPW Linked with ART",
                          "Linkage loss",
                        ]}
                      />
                    }
                  />

                  <Bar
                    yAxisId="left"
                    dataKey="reactive"
                    fill="#fd7e14"
                    name="PW Screened Reactive"
                  >
                    <LabelList
                      dataKey="reactive"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="confirmed"
                    fill="#00a084"
                    name="PW confirmed Reactive"
                  >
                    <LabelList
                      dataKey="confirmed"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="ppw"
                    fill="#ffc40c"
                    name="PPW Linked with ART"
                  >
                    <LabelList
                      dataKey="ppw"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                  <Bar
                    yAxisId="left"
                    dataKey="loss"
                    fill="#dd1e47"
                    name="Linkage loss"
                  >
                    <LabelList
                      dataKey="loss"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Evth_new;
